import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { Router } from '@angular/router';
import moment from 'moment';
import { instanceNameValidator } from 'src/app/directives/instance-name.directives';
import { PathToLiveEnvironment } from 'src/app/models/blueprints/path-to-live-environment';
import { Constants } from 'src/app/models/constants';
import { DataZone } from 'src/app/models/data-zone/data-zone';
import { Deployment } from 'src/app/models/deploy/deployment';
import { DeploymentClass } from 'src/app/models/instance-class';
import { KeyValueMap } from 'src/app/models/key-value-map';
import { Solution } from 'src/app/models/service/solution';
import { AuthService } from 'src/app/services/auth/auth.service';
import { FormUtilService } from 'src/app/services/util/form-util.service';


@Component({
    selector: 'app-deploy-instance-form',
    templateUrl: './deploy-instance-form.component.html',
    styleUrls: ['./deploy-instance-form.component.scss'],
    standalone: false
})
export class DeployInstanceFormComponent implements OnInit {
  @Input() deployment: Deployment;
  @Input() service: Solution;
  @Input() tenantDetails: any;
  @Input() versions: any;
  @Input() buildNumber: any;
  @Input() blueprint: any;
  @Input() allInstances: any;
  @Output() changedBuildVersion = new EventEmitter<string>();
  @Output() submitDisable = new EventEmitter<string>();


  DeploymentClass = DeploymentClass;
  createInstanceForm: FormGroup;

  Constants = Constants;

  DataZone = DataZone;

  weekDays: string[] = moment.weekdays();
  moment = moment;
  instanceName = false;
  devInstanceEnvironment: any;
  envt: any;
  finalBuild: any;
  submitDisableData: any;
  classDropdown: any;

  constructor(private formBuilder: FormBuilder) {
  }

  ngOnInit(): void {
    this.envt = window.location.href.split('.')[0].split('/')[2];
    this.createForm();
  }

  getDeployment(): Deployment {
    if (!FormUtilService.validateForm(this.createInstanceForm)) {
      return;
    }
    return this.createInstanceForm.getRawValue();
  }

  onClick(): void {
    this.instanceName =true;
  }

  getBuildVersion(buildVersion?: any): void {
    this.changedBuildVersion.emit(buildVersion);
  }

  getVersion(value): void {
    const data = value.split(':')[1].trim();
    const selectedVersion = this.versions.find(version => version.id === data);
    this.populateReleaseVersion(selectedVersion);
  }

   private createForm(): void {

    const instanceClass = this.deployment.deploymentClass;
    // if ((instanceClass === DeploymentClass.B && this.deployment.targetEnvironment !== PathToLiveEnvironment.LIVE)
    //   || instanceClass === DeploymentClass.C) {
    if (instanceClass === DeploymentClass.B || instanceClass === DeploymentClass.C) {
      this.classDropdown = [DeploymentClass.B, DeploymentClass.C];
    } else {
      this.classDropdown = [instanceClass];
    }

    this.devInstanceEnvironment = this.deployment.targetEnvironment ? this.deployment.targetEnvironment :
      this.deployment.deploymentClass === DeploymentClass.D ? 'Development' : this.deployment.dataZone;
    this.deployment.blueprintVersionId = this.versions[0]?.id;
    this.populateReleaseVersion(this.versions[0]);
    const notAvailable = {version: 'Release Version not Available', releaseVersion: 'Release Version not Available'};
    if (this.finalBuild?.length === 0) {
      this.submitDisableData = true;
      this.submitDisable.emit(this.submitDisableData);
      this.finalBuild = [...this.finalBuild, notAvailable];
    }
    const formConfig: any = {
      name: [this.deployment.name, [Validators.required, Validators.maxLength(16),
        Validators.pattern(/^(?=.*[a-zA-Z])([a-zA-Z0-9 ]+)$/), instanceNameValidator(this.allInstances)]],
      // region: [this.tenantDetails.temenosRegion],
      region: [this.tenantDetails.region],
      deploymentClass: [this.deployment.deploymentClass],
      dataZone: [{ value: this.deployment.dataZone, disabled: true }],
      blueprintId: [this.deployment.blueprintId],
      targetEnvironment: [this.deployment.targetEnvironment],
      blueprintVersionId: [this.deployment.blueprintVersionId, Validators.required],
      buildNumber: [this.finalBuild[0].version],
    };

    // if (this.deployment?.dataZone === DataZone.LIVE) {
    //   formConfig.dayOfTheWeek = [undefined, Validators.required];
    //   formConfig.startingHour = [undefined, Validators.required];
    //   formConfig.endingHour = [undefined, Validators.required];
    // }

    this.createInstanceForm = this.formBuilder.group(formConfig);
  }

  private populateReleaseVersion(value): void {
    const initialBuildNumbers = this.buildNumber;
    let finalBuildValue: any = [];
    initialBuildNumbers.forEach(build => {
      if(build?.capabilities?.length > 0) {
        if(value?.capabilities?.length <= build?.capabilities?.length) {
          let add = true;
          value.capabilities.forEach(capability => {
            if(build.capabilities.find(buildCapability => buildCapability.name === capability.name)) {
              return;
            } else {
              add = false;
            }
          });
          if (add) {
            finalBuildValue = [...finalBuildValue, build];
          }
        }
      } else {
      finalBuildValue = [...finalBuildValue, build];
      }
    });
    this.finalBuild = finalBuildValue;
  }

}
